// Wording for the Unify launch: the banner and the "what's new" tour shown to
// existing Sematics users. Plain British English, no claims the product can't
// back up. Images are masked screenshots (no client data) in public/img/unify/tour.

export const BANNER = {
  label: 'New',
  title: 'Sematics has a new look.',
  lede: 'Same data, a faster app, and you can switch back at any time.',
  switchButton: 'Switch to Unify',
  tourButton: "What's new",
  dismiss: 'Dismiss',
}

export const TOUR = {
  label: 'Unify',
  slides: [
    {
      title: 'Sematics has a new look',
      text: 'The same monitoring, records and alerts you use today, in a faster, cleaner app. Your data, users and settings are already there.',
      image: 'overview',
      alt: 'The Unify overview dashboard',
    },
    {
      title: 'See your whole site at a glance',
      text: 'Site plans show every sensor in place, with a live heatmap you can play back.',
      image: 'plan',
      alt: 'A site plan with sensors and a temperature heatmap',
    },
    {
      title: 'Incidents, start to finish',
      text: 'Acknowledge, record the root cause and actions, and see progress to 100% in one place. Complete several at once.',
      image: 'incident',
      alt: 'An incident with its chart, compliance steps and timeline',
    },
    {
      title: 'See cause and effect',
      text: 'Stack charts on one timeline, such as door openings under freezer temperature, to see what caused a rise.',
      image: 'stacked',
      alt: 'Freezer temperature with a door opening chart stacked underneath',
    },
    {
      title: 'Quicker every day',
      text: 'Search anything, switch company and move between pages from the keyboard. Choose light or dark, and sign in with a passkey.',
      image: 'shortcuts',
      alt: 'The keyboard shortcuts card',
    },
    {
      title: 'Help when you need it',
      text: 'Step-by-step guides and short videos for everything in Unify.',
      image: 'docs',
      alt: 'A guide in the Sematics documentation, with a video',
    },
  ],
  final: {
    title: 'Ready to switch?',
    text: 'You can move back to classic Sematics from your profile at any time.',
  },
  back: 'Back',
  next: 'Next',
  skip: 'Not now',
  switchButton: 'Switch to Unify',
  lookButton: 'Take a look first',
  laterButton: 'Not now',
}
